<template>
  <div class="demo">
    <br>
    <v-container>
      <v-card outlined shaped color="orange lighten-5">
        <v-card-title>
          <span class="text-h5">Üdvözöljük!</span>
        </v-card-title>
      <v-container>
      <p>Az alábbi alkalmazás kipróbálásával lehetősége nyílik betekintést nyerni az általunk készített programok kinézetébe, illetve a legalapvetőbb funkciók működésébe:</p>
      <ul>
        <li>adatrögzítés, módosítás, törlés;</li>
        <li>dokumentum generálás;</li>
        <li>e-mail küldés;</li>
      </ul>
      <br>
      <p>A Demo Alkalmazással egy jogszabályoknak megfelelő meghatalmazást tud generálni, amit felhasználhat bármilyen hivatalos ügyintézéshez.</p>
      </v-container>
      </v-card>
      <br>
      <v-row justify="center">
        <v-col cols="12">
      <v-alert
        icon="question_answer"
        prominent
        type="info"
        text
      >
        <v-row align="center">
          <v-col class="grow">
            Kérjen ajánlatot az Ön igényeire szabott alkalmazás készítésére!
          </v-col>
          <v-col class="shrink">
            <v-btn outlined color="info" @click="goToContact">Ajánlatkérés</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>
  </v-row>

    </v-container>

    <center>
      <v-progress-circular
      :size="70"
      :width="7"
      color="red"
      indeterminate
      v-if="!auth_finish"
    ></v-progress-circular>
    </center>

    <div v-if="auth_finish">

    <v-tabs
      v-model="tab"
      centered
      grow
      icons-and-text
      color="black"
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Ügyfelek
        <v-icon>account_circle</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        Meghatalmazás
        <v-icon>edit_note</v-icon>
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
      value="tab-1"
      >
        <Customers></Customers>
      </v-tab-item>
      <v-tab-item
      value="tab-2"
      >
        <Documents></Documents>
      </v-tab-item>
    </v-tabs-items>

    </div>

  </div>
</template>

<script>
import EventBus from '@/EventBus';
import Customers from './Customers.vue'
import Documents from './Documents.vue'
import firebase from '@/firebaseinit';
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";
const auth = getAuth(firebase);

export default {
  name: 'Demo',
  components: {
    Customers,
    Documents
  },
  data: () => ({
      tab: 'tab-1',
      recaptcha_token: '',
      auth_finish: false,
  }),
  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded()
      this.recaptcha_token = await this.$recaptcha('login')
    },
    User: function () {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          console.log(user);
          this.auth_finish = true;
        } else {
          console.log('Nincs bejelentkezett felhasználó!');
          this.AnonymousLogin()
        }
      });
    },
    AnonymousLogin: async function () {
      this.abLoading = true
      await this.recaptcha()
      this.$http.post('/recaptcha', {
      token: this.recaptcha_token
      })
      .then((response) => {
        if (response.data['success'] == 'true') {
          signInAnonymously(auth)
          .then((response) => {
            console.log(response);
            this.auth_finish = true;
          })
          .catch((error) => {
            console.log(error);
          });
          this.abLoading = false
        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    refreshCustomers() {
      EventBus.$emit('refreshCustomers')
    },
    goToContact: async function() {
      await window.scrollTo(0,0);
      this.$router.push({path: '/kapcsolat'});
    },
  },
  watch: {
    tab: function (value) {
      if (value == 'tab-2') {
        this.refreshCustomers()
      }
    }
  },
  mounted(){
   this.User()
  }
}
</script>
